import React from 'react'
import checkModule from './checkModule'
import StorefrontFooter from './storefront-footer.component'
import Footer from './footer.component'

function FooterWrapper(props) {
  return (
    <>
      {checkModule.isFooterKw ? <StorefrontFooter /> : null}
      {checkModule.isFooterKsa ? <Footer history={props.history}/> : null}
    </>
  )
}

export default FooterWrapper